// ============================================================================
// SPANISH TRANSLATIONS - CHAPTER 2: EL ÉXODO
// ============================================================================
// Niveles 14-26 (13 niveles, 39 preguntas)

export const chapter2Translations = {
  name: "El Éxodo",
  description: "La liberación del pueblo de Dios... Conocer a Dios transforma nuestras vidas",
  
  spiritualWisdom: {
    principle: "El conocimiento de Dios libera y transforma",
    scripture: "Conoceréis la verdad, y la verdad os hará libres (Juan 8:32)",
    application: "Como Israel fue liberado de Egipto, el conocimiento de Dios nos libera de la esclavitud espiritual"
  },
  
  levels: {
    14: {
      name: "Moisés Salvado de las Aguas",
      challenge: "La mujer concibió y dio a luz un hijo. Al ver que era hermoso...",
      easy: {
        question: "¿En qué escondió la madre de Moisés a su hijo?",
        options: ["Una cueva", "Una cesta de juncos", "Una canasta", "Una casa"],
        hint: "Este recipiente flotaba en el Nilo",
        funFact: "🏺 ¡La cesta de juncos estaba recubierta de brea para ser impermeable!"
      },
      medium: {
        question: "¿Quién encontró a Moisés entre los juncos?",
        options: [
          "La hija del Faraón",
          "Una sirvienta egipcia",
          "Su hermana Miriam",
          "Un sacerdote egipcio"
        ],
        hint: "Un miembro de la familia real egipcia",
        funFact: "👑 ¡Irónicamente, es la familia del Faraón quien salva a quien lo desafiará!"
      },
      hard: {
        question: "¿Cómo utiliza la Providencia divina incluso a nuestros enemigos?",
        options: [
          "Convirtiéndolos",
          "Orquestando las circunstancias para cumplir sus designios",
          "Castigándolos",
          "Ignorándolos"
        ],
        hint: "Se trata de ver la mano de Dios en los eventos",
        funFact: "✨ ¡Moisés creció en el palacio de quien oprimía a su pueblo!"
      }
    },
    
    15: {
      name: "La Zarza Ardiente",
      challenge: "El ángel del Señor se le apareció en una llama de fuego...",
      easy: {
        question: "¿Qué debía quitarse Moisés ante la zarza ardiente?",
        options: ["Sus joyas", "Sus sandalias", "Su manto", "Su turbante"],
        hint: "Lo que se lleva en los pies",
        funFact: "👡 ¡Descalzarse expresa respeto en tierra santa!"
      },
      medium: {
        question: "¿Qué nombre revela Dios a Moisés?",
        options: [
          "El Señor",
          "YO SOY EL QUE SOY",
          "El Todopoderoso",
          "El Creador"
        ],
        hint: "Un nombre que expresa la existencia absoluta",
        funFact: "🔥 ¡YHWH (Yo Soy) revela la esencia eterna de Dios!"
      },
      hard: {
        question: "¿Qué nos enseña la zarza que arde sin consumirse?",
        options: [
          "La magia existe",
          "Dios trasciende las leyes naturales",
          "El fuego es sagrado",
          "Las plantas son mágicas"
        ],
        hint: "Se trata de la naturaleza divina que supera nuestra comprensión",
        funFact: "🌿 ¡La zarza simboliza que la presencia divina santifica sin destruir!"
      }
    },

    16: {
      name: "Las Diez Plagas de Egipto",
      challenge: "El Faraón endureció su corazón y no los escuchó...",
      easy: {
        question: "¿Cuál fue la primera plaga de Egipto?",
        options: ["Las ranas", "El agua convertida en sangre", "Las moscas", "Los piojos"],
        hint: "Afectó al Nilo, fuente de vida para Egipto",
        funFact: "🩸 ¡El Nilo era adorado como un dios, y Dios mostró su superioridad!"
      },
      medium: {
        question: "¿Cuál fue la última y más terrible de las plagas?",
        options: [
          "El granizo",
          "Las tinieblas",
          "La muerte de los primogénitos",
          "Las langostas"
        ],
        hint: "Esta plaga afectó directamente a las familias",
        funFact: "😢 ¡Esta plaga finalmente rompió el orgullo del Faraón y liberó a Israel!"
      },
      hard: {
        question: "¿Por qué Dios endurece el corazón del Faraón?",
        options: [
          "Para castigarlo",
          "Para manifestar su gloria y poder",
          "Por maldad",
          "Para prolongar los sufrimientos"
        ],
        hint: "Se trata de revelar quién es el Dios verdadero",
        funFact: "⚡ ¡Las plagas demuestran que YHWH es más poderoso que todos los dioses egipcios!"
      }
    },

    17: {
      name: "La Pascua",
      challenge: "Tomad un cordero... y pondréis de su sangre en los postes...",
      easy: {
        question: "¿Dónde debían poner los israelitas la sangre del cordero?",
        options: [
          "En sus ropas",
          "En los dinteles y postes de las puertas",
          "En sus frentes",
          "En copas"
        ],
        hint: "En la entrada de sus casas",
        funFact: "🩸 ¡La sangre en la puerta era la señal de protección divina!"
      },
      medium: {
        question: "¿Cómo debían comer el cordero pascual?",
        options: [
          "Sentados cómodamente",
          "Solo en familia",
          "Con los lomos ceñidos, sandalias en los pies, bastón en la mano",
          "En silencio"
        ],
        hint: "Listos para partir",
        funFact: "🚶 ¡Debían estar listos para partir rápidamente hacia la libertad!"
      },
      hard: {
        question: "¿Cómo prefigura el Cordero pascual a Cristo?",
        options: [
          "Por su blancura",
          "Por su sacrificio sustitutivo que salva de la muerte",
          "Por su mansedumbre",
          "Por su edad"
        ],
        hint: "Se trata del sacrificio que libra de la condenación",
        funFact: "🐑 ¡Jesús es llamado 'el Cordero de Dios que quita el pecado del mundo'!"
      }
    },

    18: {
      name: "El Cruce del Mar Rojo",
      challenge: "Moisés extendió su mano sobre el mar...",
      easy: {
        question: "¿Cómo cruzaron los israelitas el mar?",
        options: [
          "En barco",
          "Nadando",
          "A pie seco",
          "En balsa"
        ],
        hint: "El fondo del mar era transitable",
        funFact: "🌊 ¡Dios transformó un obstáculo en camino de liberación!"
      },
      medium: {
        question: "¿Qué les pasó a los egipcios que perseguían?",
        options: [
          "Dieron media vuelta",
          "Fueron tragados por las aguas",
          "Se perdieron",
          "Se unieron a Israel"
        ],
        hint: "Las aguas volvieron sobre ellos",
        funFact: "⚔️ ¡El ejército más poderoso del mundo fue destruido en un instante!"
      },
      hard: {
        question: "¿Qué simboliza este cruce en nuestra vida espiritual?",
        options: [
          "La huida de los problemas",
          "El paso de la esclavitud del pecado a la libertad en Dios",
          "La superioridad de Israel",
          "La destrucción de los enemigos"
        ],
        hint: "Se trata de una transformación espiritual",
        funFact: "🗽 ¡El Mar Rojo representa el bautismo: muerte a lo viejo, vida nueva!"
      }
    },

    19: {
      name: "El Maná en el Desierto",
      challenge: "¿Qué es esto? Porque no sabían qué era...",
      easy: {
        question: "¿Cuánto tiempo cayó el maná?",
        options: ["10 años", "20 años", "40 años", "50 años"],
        hint: "El mismo número que los años en el desierto",
        funFact: "🍞 ¡Durante 40 años, Dios alimentó milagrosamente a 2 millones de personas!"
      },
      medium: {
        question: "¿Qué pasaba si guardaban el maná más de un día?",
        options: [
          "Se volvía más sabroso",
          "Se multiplicaba",
          "Se pudrió y olía mal",
          "Se endurecía"
        ],
        hint: "Excepto el viernes para el sábado",
        funFact: "🪱 ¡Dios enseñaba así la dependencia diaria de Él!"
      },
      hard: {
        question: "¿Cómo nos enseña el maná la confianza?",
        options: [
          "Almacenando para el futuro",
          "Contando con la providencia diaria de Dios",
          "Trabajando más duro",
          "Compartiendo equitativamente"
        ],
        hint: "Se trata de confiar día tras día",
        funFact: "🙏 ¡'Danos hoy nuestro pan de cada día' viene de esta experiencia!"
      }
    },

    20: {
      name: "El Agua de la Roca",
      challenge: "Golpearás la roca, y saldrá agua de ella...",
      easy: {
        question: "¿Con qué debía Moisés golpear la roca?",
        options: ["Su mano", "Su vara", "Una piedra", "Un martillo"],
        hint: "El instrumento de los milagros de Moisés",
        funFact: "⚡ ¡La vara de Moisés era el instrumento del poder divino!"
      },
      medium: {
        question: "¿Por qué murmuraba el pueblo contra Moisés?",
        options: [
          "No había agua para beber",
          "Faltaba la comida",
          "El camino era demasiado largo",
          "Hacía demasiado calor"
        ],
        hint: "Una necesidad vital en el desierto",
        funFact: "💧 ¡El agua es más esencial que la comida para la supervivencia!"
      },
      hard: {
        question: "¿Qué representa espiritualmente el agua de la roca?",
        options: [
          "Los recursos naturales",
          "La vida espiritual que brota de Cristo, la Roca",
          "La recompensa de los esfuerzos",
          "La magia divina"
        ],
        hint: "Pablo dice que esta roca era Cristo",
        funFact: "🗿 ¡Cristo es la Roca golpeada de la cual brota la vida eterna!"
      }
    },

    21: {
      name: "El Monte Sinaí",
      challenge: "Todo el monte Sinaí humeaba, porque el Señor había descendido sobre él...",
      easy: {
        question: "¿Cuántos mandamientos dio Dios?",
        options: ["5", "7", "10", "12"],
        hint: "Un número redondo y perfecto",
        funFact: "📜 ¡Los Diez Mandamientos son el fundamento moral de la humanidad!"
      },
      medium: {
        question: "¿En qué estaban escritos los mandamientos?",
        options: [
          "Papiro",
          "Pergamino",
          "Dos tablas de piedra",
          "Bronce"
        ],
        hint: "Un material duradero escrito por el dedo de Dios",
        funFact: "✍️ ¡Escritos por Dios mismo para mostrar su importancia eterna!"
      },
      hard: {
        question: "¿Cuál es el objetivo de los mandamientos divinos?",
        options: [
          "Castigar a los hombres",
          "Revelar la santidad de Dios y guiar hacia la felicidad",
          "Crear reglas complejas",
          "Separar a los pueblos"
        ],
        hint: "Se trata de revelar el carácter divino y el camino del bien",
        funFact: "⚖️ ¡Los mandamientos revelan el amor: amor a Dios y al prójimo!"
      }
    },

    22: {
      name: "El Becerro de Oro",
      challenge: "Haznos dioses que vayan delante de nosotros...",
      easy: {
        question: "¿Con qué hizo Aarón el becerro de oro?",
        options: [
          "Monedas de oro",
          "Los pendientes de oro del pueblo",
          "Joyas preciosas",
          "Oro del desierto"
        ],
        hint: "Joyas personales donadas por el pueblo",
        funFact: "👂 ¡El pueblo dio sus joyas para crear su propio ídolo!"
      },
      medium: {
        question: "¿Cuál fue la reacción de Moisés al ver el becerro?",
        options: [
          "Lloró",
          "Oró",
          "Rompió las tablas de la ley",
          "Solo se enojó"
        ],
        hint: "Un gesto simbólico de la alianza rota",
        funFact: "💥 ¡Romper las tablas simbolizaba que la alianza estaba rota!"
      },
      hard: {
        question: "¿Por qué la idolatría es tan peligrosa espiritualmente?",
        options: [
          "Es costosa",
          "Desvía el corazón del Dios verdadero hacia las criaturas",
          "Divide a las familias",
          "Está prohibida"
        ],
        hint: "Se trata de dar a la criatura lo que pertenece al Creador",
        funFact: "💔 ¡La idolatría rompe la relación exclusiva con el Dios vivo!"
      }
    },

    23: {
      name: "El Tabernáculo",
      challenge: "Me harán un santuario, y habitaré en medio de ellos...",
      easy: {
        question: "¿Cómo se llamaba la tienda sagrada de los israelitas?",
        options: ["El Templo", "El Tabernáculo", "El Santuario", "El Arca"],
        hint: "El nombre significa 'tienda de reunión'",
        funFact: "⛺ ¡El Tabernáculo era la 'casa móvil' de Dios con su pueblo!"
      },
      medium: {
        question: "¿Qué contenía el Arca de la Alianza?",
        options: [
          "Las joyas del sumo sacerdote",
          "Las tablas de la ley, el maná, la vara de Aarón",
          "Monedas de oro",
          "Los rollos de la Torá"
        ],
        hint: "Tres objetos que simbolizan la alianza con Dios",
        funFact: "📦 ¡El Arca contenía los 'recuerdos' de la fidelidad divina!"
      },
      hard: {
        question: "¿Qué simboliza el Tabernáculo en nuestra relación con Dios?",
        options: [
          "Un edificio religioso",
          "La presencia de Dios que habita entre nosotros y en nosotros",
          "Un lugar solo de sacrificio",
          "Un símbolo nacional"
        ],
        hint: "Se trata de la presencia divina accesible",
        funFact: "🏠 ¡'Vuestro cuerpo es templo del Espíritu Santo' según Pablo!"
      }
    },

    24: {
      name: "El Sumo Sacerdote Aarón",
      challenge: "Consagrarás a Aarón y a sus hijos para que sean mis sacerdotes...",
      easy: {
        question: "¿Quién fue el primer sumo sacerdote de Israel?",
        options: ["Moisés", "Aarón", "Josué", "Eleazar"],
        hint: "El hermano de Moisés",
        funFact: "👨‍⚕️ ¡Aarón fundó el linaje sacerdotal que duró más de 1000 años!"
      },
      medium: {
        question: "¿Qué llevaba el sumo sacerdote sobre su pecho?",
        options: [
          "Una cruz de oro",
          "El pectoral con las doce piedras preciosas",
          "Un medallón",
          "Una cadena de oro"
        ],
        hint: "Doce piedras que representan las doce tribus",
        funFact: "💎 ¡El sumo sacerdote llevaba simbólicamente a todo Israel sobre su corazón!"
      },
      hard: {
        question: "¿Cómo cumple Jesús el papel de Sumo Sacerdote?",
        options: [
          "Llevando vestiduras sagradas",
          "Ofreciendo su propia sangre una vez para siempre",
          "Sirviendo en el Templo",
          "Descendiendo de Aarón"
        ],
        hint: "Se trata de un sacrificio perfecto y definitivo",
        funFact: "✝️ ¡Jesús es Sumo Sacerdote eterno según el orden de Melquisedec!"
      }
    },

    25: {
      name: "Los Sacrificios",
      challenge: "Si alguno de vosotros ofrece una ofrenda al Señor...",
      easy: {
        question: "¿Cuál era el sacrificio diario en el Tabernáculo?",
        options: [
          "El sacrificio de paz",
          "El holocausto de la mañana y de la tarde",
          "El sacrificio por el pecado",
          "La ofrenda de tortas"
        ],
        hint: "Dos veces al día, mañana y tarde",
        funFact: "🔥 ¡El fuego en el altar nunca debía apagarse!"
      },
      medium: {
        question: "¿Qué simbolizaba la imposición de manos sobre el animal?",
        options: [
          "La bendición",
          "La transferencia de los pecados a la víctima",
          "El afecto por el animal",
          "La consagración"
        ],
        hint: "Un gesto de sustitución",
        funFact: "🤲 ¡El animal moría en lugar del pecador - principio de sustitución!"
      },
      hard: {
        question: "¿Cómo prefiguran estos sacrificios la obra de Cristo?",
        options: [
          "Por su número",
          "Por la sustitución: el inocente muere por el culpable",
          "Por su costo",
          "Por su belleza"
        ],
        hint: "Se trata del principio del inocente que toma el lugar del culpable",
        funFact: "🐑 ¡'Fue herido por nuestras rebeliones, molido por nuestros pecados'!"
      }
    },

    26: {
      name: "En las Fronteras de la Tierra Prometida",
      challenge: "Enviaré delante de ti un ángel, y echaré fuera a los cananeos...",
      easy: {
        question: "¿Cuántos espías fueron enviados para explorar la Tierra Prometida?",
        options: ["10", "12", "20", "40"],
        hint: "Uno por tribu de Israel",
        funFact: "🕵️ ¡Solo 2 de los 12 espías dieron un informe alentador!"
      },
      medium: {
        question: "¿Qué espías animaron al pueblo a entrar en la tierra?",
        options: [
          "Aarón y Moisés",
          "Josué y Caleb",
          "Gad y Aser",
          "Rubén y Simeón"
        ],
        hint: "Dos hombres de fe que vieron las promesas de Dios",
        funFact: "🦁 ¡Josué y Caleb fueron los únicos de su generación que entraron en Canaán!"
      },
      hard: {
        question: "¿Por qué vagó Israel 40 años en el desierto?",
        options: [
          "Para castigarlos",
          "Por su incredulidad ante las promesas divinas",
          "Para entrenarlos en el combate",
          "Para encontrar el camino correcto"
        ],
        hint: "Se trata de una falta de confianza en Dios",
        funFact: "🏜️ ¡Una generación entera tuvo que morir por la incredulidad!"
      }
    }
  }
};

export default chapter2Translations;
